import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "sorriso_admin_token";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const authedAxios = useCallback(() => {
    const instance = axios.create({ baseURL: API });
    if (token) instance.defaults.headers.common.Authorization = `Bearer ${token}`;
    return instance;
  }, [token]);

  const fetchMe = useCallback(async (tk) => {
    try {
      const res = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${tk}` },
      });
      setUser(res.data);
      return true;
    } catch (e) {
      setUser(null);
      setToken(null);
      localStorage.removeItem(TOKEN_KEY);
      return false;
    }
  }, []);

  useEffect(() => {
    const init = async () => {
      if (token) {
        await fetchMe(token);
      }
      setLoading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    const { access_token, user: u } = res.data;
    setToken(access_token);
    setUser(u);
    localStorage.setItem(TOKEN_KEY, access_token);
    return u;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem(TOKEN_KEY);
  };

  const applyAuthResponse = ({ access_token, user: u }) => {
    setToken(access_token);
    setUser(u);
    localStorage.setItem(TOKEN_KEY, access_token);
  };

  return (
    <AuthContext.Provider value={{ token, user, loading, login, logout, authedAxios, applyAuthResponse }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
